import React, { useEffect, useState } from 'react'
import { Alert, Button, Spinner } from 'react-bootstrap'

const GITHUB_API_URL =
  'https://api.github.com/repos/datasets/s-and-p-500-companies/commits?path=data/constituents.csv&per_page=1'

function formatDate(isoString) {
  if (!isoString) return '—'
  return isoString.split('T')[0]
}

function Snp500UpdatePanel({ s3LastUpdated, jobStatus, onUpdate }) {
  const [githubLastUpdated, setGithubLastUpdated] = useState(null)

  useEffect(() => {
    fetch(GITHUB_API_URL)
      .then((res) => res.json())
      .then((commits) => {
        if (commits && commits.length > 0) {
          setGithubLastUpdated(commits[0].commit.committer.date)
        }
      })
      .catch(() => {})
  }, [])

  const isPending = jobStatus === 'pending'

  return (
    <div className="mb-4">
      <dl className="row mb-3">
        <dt className="col-sm-3 text-muted fw-normal small">S3 last updated</dt>
        <dd className="col-sm-9">{formatDate(s3LastUpdated)}</dd>
        <dt className="col-sm-3 text-muted fw-normal small">GitHub source</dt>
        <dd className="col-sm-9">{githubLastUpdated ? formatDate(githubLastUpdated) : '…'}</dd>
      </dl>
      {jobStatus === 'failed' && (
        <Alert variant="danger" className="mb-3">
          Update failed. Please try again.
        </Alert>
      )}
      <Button variant="primary" onClick={onUpdate} disabled={isPending}>
        {isPending && (
          <Spinner
            animation="border"
            size="sm"
            className="me-2"
            role="status"
            aria-label="Updating"
          >
            <span className="visually-hidden">Updating…</span>
          </Spinner>
        )}
        Update
      </Button>
    </div>
  )
}

export default Snp500UpdatePanel
